/**
 * init adwords
 */
export const initAdwords = () => {
    const img = document.createElement('img');
    img.style.borderStyle = 'none';
    img.setAttribute('src', '//www.googleadservices.com/pagead/conversion/871411056/?label=V3bRCPqigHEQ8NrCnwM&amp;guid=ON&amp;script=0');
    img.setAttribute('height', '1');
    img.setAttribute('width', '1');
    document.body.appendChild(img);
};